import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateInput } from "@air/primitive-date-input";
import { Label } from "@air/primitive-label";
import { parseAirDateToISO } from "@air/utilities";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
export const BoardCollectionCustomFieldDateInput = (param)=>{
    let { field, required, onDateSelection, disabled = false } = param;
    const handleOnChange = (date)=>{
        const dateValue = date === null || date === void 0 ? void 0 : date.toISOString();
        if (dateValue === field.dateValue) return;
        onDateSelection(dateValue);
    };
    const Icon = customFieldIconMap[field.type.title];
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col gap-1",
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                className: "flex items-center font-semibold",
                htmlFor: field.id,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "mr-1 flex size-4 text-grey-9"
                    }),
                    field.name,
                    required ? "*" : ""
                ]
            }),
            /*#__PURE__*/ _jsx(DateInput, {
                disabled: disabled,
                showCalendarIcon: false,
                size: "large",
                selected: field.dateValue ? parseAirDateToISO(field.dateValue) : undefined,
                placeholderText: "Add a date",
                onChange: handleOnChange,
                id: field.id,
                name: field.name,
                className: "w-full"
            })
        ]
    });
};
